/* ============================================================
   YINN Scent Guide — interaction module
   Vanilla JS only. Loaded on demand by yinn-scent-guide section.
   Scope: each [data-yinn-scent-guide] root is isolated.
   Supports Theme Editor dynamic section load/unload.
   Main content is server-rendered by Liquid; JS only toggles.
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-yinn-scent-guide]';

  // Sprite geometry per set (mirrors Asset_Map_v3.json)
  var GEOM = {
    main: { w: 1254, h: 1254, cw: 627, ch: 627 },
    icon: { w: 1254, h: 1254, cw: 314, ch: 314 },
    info: { w: 1448, h: 1086, cw: 362, ch: 362 }
  };

  function setOf(file) {
    if (file.indexOf('sheet_left_main_') === 0) return 'main';
    if (file.indexOf('sheet_right_icons_') === 0) return 'icon';
    if (file.indexOf('sheet_left_info_cards_') === 0) return 'info';
    return 'main';
  }

  function buildPos(map) {
    var pos = {};
    var sheets = (map && map.sheets) || {};
    Object.keys(sheets).forEach(function (file) {
      var s = sheets[file];
      var set = setOf(file);
      (s.assets || []).forEach(function (a) {
        pos[a.asset_id] = { set: set, col: a.col, row: a.row, sheet: file };
      });
    });
    return pos;
  }

  function ScentGuide(root, assetMap, sheetUrls) {
    this.root = root;
    this.sheetUrls = sheetUrls || {};
    this.spritePos = {};
    this.lensNav = root.querySelector('.sg3-lens-nav');
    this.objectNav = root.querySelector('.sg3-object-nav');
    this.currentLens = this.lensNav
      ? this.lensNav.querySelector('.sg3-lens-btn').getAttribute('data-lens')
      : null;
    this._onClick = this._onClick.bind(this);
    this._init(assetMap);
  }

  ScentGuide.prototype._init = function (assetMap) {
    if (this.lensNav) this.lensNav.addEventListener('click', this._onClick);
    if (this.objectNav) this.objectNav.addEventListener('click', this._onClick);
    if (assetMap && assetMap.sheets) {
      this.spritePos = buildPos(assetMap);
    }
    this._paintAll();
    this._showCurrent();
  };

  ScentGuide.prototype.destroy = function () {
    if (this.lensNav) this.lensNav.removeEventListener('click', this._onClick);
    if (this.objectNav) this.objectNav.removeEventListener('click', this._onClick);
  };

  ScentGuide.prototype._onClick = function (e) {
    var lensBtn = e.target.closest('.sg3-lens-btn');
    if (lensBtn) {
      this.showLens(lensBtn.getAttribute('data-lens'));
      return;
    }
    var objBtn = e.target.closest('.sg3-object-btn');
    if (objBtn) {
      this.selectObject(objBtn.getAttribute('data-lens'), objBtn.getAttribute('data-obj'));
    }
  };

  ScentGuide.prototype._paint = function (el) {
    var id = el.getAttribute('data-sprite');
    if (!id) return;
    var p = this.spritePos[id];
    var sheetUrl = p && this.sheetUrls[p.sheet];
    if (!p || !sheetUrl) return;
    var g = GEOM[p.set];
    var dw = el.classList.contains('sg3-main-visual') ? 380
           : el.classList.contains('sg3-info-icon') ? 72 : 56;
    var dh = dw;
    var sx = dw / g.cw, sy = dh / g.ch;
    var bx = -p.col * dw, by = -p.row * dh;
    var bw = g.w * sx, bh = g.h * sy;
    var existing = el.style.backgroundImage || '';
    if (existing.indexOf('url(') !== -1) return;
    el.style.backgroundImage = 'url(' + sheetUrl + ')';
    el.style.backgroundPosition = bx + 'px ' + by + 'px';
    el.style.backgroundSize = bw + 'px ' + bh + 'px';
    el.style.backgroundRepeat = 'no-repeat';
  };

  ScentGuide.prototype._paintAll = function () {
    var self = this;
    this.root.querySelectorAll('[data-sprite]').forEach(function (el) {
      self._paint(el);
    });
  };

  ScentGuide.prototype.showLens = function (lens) {
    this.currentLens = lens;
    if (this.lensNav) {
      this.lensNav.querySelectorAll('.sg3-lens-btn').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-lens') === lens ? 'true' : 'false');
      });
    }
    if (this.objectNav) {
      this.objectNav.querySelectorAll('.sg3-object-btn').forEach(function (b) {
        b.hidden = (b.getAttribute('data-lens') !== lens);
      });
    }
    var first = this.objectNav
      ? this.objectNav.querySelector('.sg3-object-btn[data-lens="' + lens + '"]')
      : null;
    if (first) this.selectObject(lens, first.getAttribute('data-obj'));
  };

  ScentGuide.prototype.selectObject = function (lens, obj) {
    this.root.querySelectorAll('.sg3-object-pane').forEach(function (p) {
      var active = (p.getAttribute('data-lens') === lens && p.getAttribute('data-obj') === obj);
      p.style.display = active ? 'flex' : 'none';
      p.hidden = !active;
    });
    this.root.querySelectorAll('.sg3-content-pane').forEach(function (p) {
      var active = (p.getAttribute('data-lens') === lens && p.getAttribute('data-obj') === obj);
      p.style.display = active ? 'block' : 'none';
      p.hidden = !active;
    });
    if (this.objectNav) {
      this.objectNav.querySelectorAll('.sg3-object-btn').forEach(function (b) {
        b.setAttribute('aria-pressed',
          (b.getAttribute('data-lens') === lens && b.getAttribute('data-obj') === obj) ? 'true' : 'false');
      });
    }
  };

  ScentGuide.prototype._showCurrent = function () {
    if (this.currentLens) this.showLens(this.currentLens);
  };

  // ---- Bootstrap ----
  function readJson(root, sel) {
    var node = root.querySelector(sel);
    if (!node) return null;
    try {
      var raw = (node.textContent || node.innerText || '{}').replace(/^﻿/, '').trim();
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  var instances = new WeakMap();

  function mount(root) {
    if (instances.has(root)) return;
    var sheetUrls = readJson(root, '#sg3-sheets') || {};
    var map = readJson(root, '#sg3-asset-map');
    instances.set(root, new ScentGuide(root, map, sheetUrls));
  }

  function unmount(root) {
    var inst = instances.get(root);
    if (inst) {
      inst.destroy();
      instances.delete(root);
    }
  }

  function mountAll() {
    document.querySelectorAll(SELECTOR).forEach(mount);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    var root = (t && t.matches && t.matches(SELECTOR)) ? t : (t && t.querySelector ? t.querySelector(SELECTOR) : null);
    if (root) mount(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    var root = (t && t.matches && t.matches(SELECTOR)) ? t : (t && t.querySelector ? t.querySelector(SELECTOR) : null);
    if (root) unmount(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
